export default {
  vk: {
    global: {
      href: 'https://vk.com/gorillaenergy'
    },
    kz: {
      href: 'https://vk.com/gorillaenergykz'
    }
  },
  telegram: {
    global: {
      href: 'https://t.me/gorillaenergyofficial'
    }
  },
  youtube: {
    global: {
      href: 'https://youtube.com/gorillaenergy'
    }
  },
  facebook: {
    global: {
      href: 'https://facebook.com/gorillaenergy'
    }
  },
  instagram: {
    global: {
      href: 'https://www.instagram.com/gorillaenergy.kz'
    },
    am: {
      href: 'https://www.instagram.com/gorillaenergy.arm'
    },
    ar: {
      href: 'https://www.instagram.com/gorillaenergy.uae'
    },
    cy: {
      href: 'https://www.instagram.com/gorillaenergy.cyp'
    },
    fr: {
      href: 'https://www.instagram.com/gorillaenergy.fr'
    },
    ge: {
      href: 'https://www.instagram.com/gorillaenergy.geo'
    },
    kz: {
      href: 'https://www.instagram.com/gorillaenergy.kz'
    },
    kg: {
      href: 'https://www.instagram.com/gorillaenergy.kg'
    },
    md: {
      href: 'https://www.instagram.com/gorillaenergy.mda'
    },
    ru: {
      href: 'https://www.instagram.com/gorillaenergy.rus'
    },
    ko: {
      href: 'https://www.instagram.com/gorillaenergy.kr'
    },
    sr: {
      href: 'https://www.instagram.com/gorillaenergy.sur'
    },
    tr: {
      href: 'https://www.instagram.com/gorillaenergy.tr'
    },
    tj: {
      href: 'https://www.instagram.com/gorillaenergy_tj'
    },
    uz: {
      href: 'https://www.instagram.com/gorillaenergy.uz'
    },
    by: {
      href: 'https://www.instagram.com/gorillaenergy.by'
    },
    gb: {
      href: 'https://www.instagram.com/gorillaenergy.uk'
    },
    ca: {
      href: 'https://www.instagram.com/gorillaenergy.can'
    }
  }
}
